/**
 * PricingPage - 定价页。
 *
 * 四档卡片 + 月/年切换 + 年付引导（省 2 个月）+ 加油包。
 * FAQ 集中在 /faq 中心页与首页 FAQ 区（定价页不再重复）。
 */

import { useState } from "react";
import { useTranslation } from "react-i18next";
import PricingMatrix from "../components/PricingMatrix";
import PublicLayout from "../components/PublicLayout";
import { LocalizedLink } from "../lib/lang";
import { SUPPORT_EMAIL, SUPPORT_MAILTO } from "../lib/support";

export default function PricingPage() {
  const { t } = useTranslation();
  // 命名避免 shadow 全局 setInterval（window.setInterval）
  const [billingInterval, setBillingInterval] = useState<"month" | "year">(
    "month",
  );

  return (
    <div className="pricing-page">
      <PublicLayout
        footer={
          <footer className="pricing-footer">
            {/* 左组：版权 + 联系邮箱；右组：法律链接（Creem MoR 合规：
                定价页 footer 需可直达 Terms/Privacy/AUP）+ 返回首页 */}
            <div className="pricing-footer-meta">
              <span>© {new Date().getFullYear()} {t("common.brand")}</span>
              <a href={SUPPORT_MAILTO}>{SUPPORT_EMAIL}</a>
            </div>
            <nav className="pricing-footer-links" aria-label={t("landing.footerLinks.aria")}>
              <LocalizedLink to="/terms">{t("landing.footerLinks.terms")}</LocalizedLink>
              <LocalizedLink to="/privacy">{t("landing.footerLinks.privacy")}</LocalizedLink>
              <LocalizedLink to="/aup">{t("landing.footerLinks.aup")}</LocalizedLink>
              <LocalizedLink to="/">{t("pricing.backHome")}</LocalizedLink>
            </nav>
          </footer>
        }
      >
        <div className="pricing-hero">
          <div className="pricing-header">
            <h1>{t("pricing.title")}</h1>
            <p>{t("pricing.subtitle")}</p>
          </div>

        <div className="interval-toggle">
          <button
            className={billingInterval === "month" ? "active" : ""}
            onClick={() => setBillingInterval("month")}
          >
            {t("pricing.interval.month")}
          </button>
          <button
            className={billingInterval === "year" ? "active" : ""}
            onClick={() => setBillingInterval("year")}
          >
            {t("pricing.interval.year")}
            <span className="save-badge">{t("pricing.save2")}</span>
          </button>
        </div>

        <PricingMatrix interval={billingInterval} />
      </div>

      <section className="addon-section">
        <h3>{t("pricing.addon.title")}</h3>
        <div className="addon-card">
          <div>
            <strong>{t("pricing.addon.name")}</strong>
            <span className="addon-detail">{t("pricing.addon.detail")}</span>
          </div>
          <div className="addon-price">
            <span className="price">{t("pricing.addon.price")}</span>
            <small>{t("pricing.addon.note")}</small>
          </div>
        </div>
      </section>
      </PublicLayout>
    </div>
  );
}
